import { render, staticRenderFns } from "./AppContentBlock.vue?vue&type=template&id=2c8432e7&"
import script from "./AppContentBlock.vue?vue&type=script&lang=js&"
export * from "./AppContentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports